import React from 'react';
import { ICreditCard } from '../../models/CreditCard';
import { creditCard, creditCardExpiration, postalCode, required } from '../../validation';
import { renderTextInput } from '../Form/RenderForm';
import State from '../Form/State';

interface IDetailsFormProps {
  editCard?: ICreditCard
}

const DetailsForm: React.FC<IDetailsFormProps> = props => {
  let idPrefix = props.editCard ? `editCard.${props.editCard.id}` : 'addCard'

  return (
    <>
      <div className="form-label-group">
        {renderTextInput(
          idPrefix + '.cardDetails.nameOnCard',
          'nameOnCard',
          'Name on card',
          'Name on card',
          [required]
        )}
      </div>
      <div className="form-label-group">
        {renderTextInput(
          idPrefix + '.cardDetails.cardNumber',
          'cardNumber',
          `Card number${props.editCard == null ? '' : ' (leave empty to not change)'}`,
          'Card number',
          props.editCard == null ? [required, creditCard] : [creditCard]
        )}
      </div>
      <div className="row no-gutters">
        <div className="form-label-group col-lg-6">
          {renderTextInput(
            idPrefix + '.cardDetails.expirationDate',
            'expirationDate',
            'Exp. Date (MM/YY)',
            'Expiration date (MM/YY)',
            [required, creditCardExpiration]
          )}
        </div>
      </div>
      <div className="form-label-group">
        {renderTextInput(
          idPrefix + '.cardDetails.address',
          'address',
          'Billing address',
          'Billing address',
          [required]
        )}
      </div>
      <div className="form-label-group">
        {renderTextInput(
          idPrefix + '.cardDetails.city',
          'city',
          'City',
          'City',
          [required]
        )}
      </div>
      <div className="row no-gutters">
        <div className="form-label-group col-lg-6">
          <State
            name="state"
            required={true}
            includeCanada={true} />
        </div>
        <div className="col-lg-5 offset-lg-1 form-label-group">
          {renderTextInput(
            idPrefix + '.cardDetails.zip',
            'zip',
            'Postal code',
            'Postal code',
            [required, postalCode]
          )}
        </div>
      </div>
    </>
  )
}

export default DetailsForm
